<div class="error-container">
  <div class="content-scrollable">
    <mat-card class="error-msg" [ngClass]="{
      'error': errorLevel === 'ERROR', 
      'warning': errorLevel === 'WARNING',
      'info': errorLevel === 'INFO'
    }">
      
      <div class="error-content">
        <!-- Icône -->
        <div class="icon-container">
          <fa-icon
            class="error-icon"
            [icon]="'exclamation-triangle'"
            [ngClass]="{ 'text-white': errorLevel !== 'INFO' }"
          ></fa-icon>
        </div>

          <!-- Titre -->
        <div class="title-container" [ngClass]="{ 'text-white': errorLevel !== 'INFO' }">
            <h1>
              {{ errorLevel + "_OCCURED_HOME_KIOSK" | translate: { Default: "Attention" } }}
            </h1>
        </div>
          

          <!-- Messages -->
         <div class="message-container" [ngClass]="{ 'text-white': errorLevel !== 'INFO' }">
            <mat-card-subtitle *ngIf="errorMsg"
              [innerHTML]="errorMsg"
              class="lead"
              [ngClass]="{ 'text-white': errorLevel !== 'INFO' }"
              style="font-weight: 400;"
            ></mat-card-subtitle>
            
            <mat-card-subtitle
              *ngIf="errorMsgAllLanguage"
              class="lead"
              [ngClass]="{ 'text-white': errorLevel !== 'INFO' }"
            >
              {{ errorMsgFR }}<br />
              {{ errorMsgNL }}<br />
              {{ errorMsgEN }}<br />
              {{ errorMsgDE }}
            </mat-card-subtitle>

            <mat-card-subtitle
              *ngIf="!errorMsg && !errorMsgAllLanguage"
              class="lead"
              [ngClass]="{ 'text-white': errorLevel !== 'INFO' }"
            >
              {{ "GLOBAL_ERROR_MESSAGE" | translate }}
            </mat-card-subtitle>
          </div>

      </div>

    </mat-card>

    <div *ngIf="insurerPhone || insurerWebLink" class="lead">
      <mat-card class="mt-2">
        <p>{{ errorLevel + "_PAGE_INSURER_CONTACT" | translate }}</p>
        <p *ngIf="insurerPhone">
          {{ "ERROR_PAGE_INSURER_PHONE_LABEL" | translate }}:
          <b>
            <ng-container *ngIf="!environment.kioskMode; else plainPhone">
              <a [href]="'tel:' + insurerPhone">{{ insurerPhone }}</a>
            </ng-container>
            <ng-template #plainPhone>
              <span>{{ insurerPhone }}</span>
            </ng-template>
          </b>
        </p>
        <p *ngIf="insurerWebLink && !environment.kioskMode" class="weblink-wrapper">
          {{ "ERROR_PAGE_INSURER_WEBLINK_LABEL" | translate }}:
          <b>
            <a [href]="insurerWebLink" target="_blank" rel="noopener noreferrer" class="weblink">{{ insurerWebLink }}</a>
          </b>
        </p>
      </mat-card>
    </div>
    
    <div class="text-center p-1">
      <circle-progress
        *ngIf="displayCountdown"
        [percent]="numberCountdown * 10"
        [maxPercent]="10"
        [title]="numberCountdown"
        [showUnits]="false"
        [radius]="100"
        [titleFontWeight]="600"
        [showSubtitle]="false"
        [outerStrokeWidth]="16"
        [innerStrokeWidth]="8"
        [outerStrokeColor]="'#3f51b5'"
        [innerStrokeColor]="'#d8dcf0'"
        [animation]="false"
        [animationDuration]="300"
        [radius]="70"
      ></circle-progress>
    </div>
  </div>
  
  <app-btn
    [dataTxt]="'BACK_TO_HOME'"
    [classes]="'w-100 btnAnimation'"
    (callback)="onHome()"
    [icon]="'home'"
    [iconLocation]="'left'"
  ></app-btn>
</div>
